import { TWT_USER_TRACK_HISTORY, TWT_USER_TRACK_HISTORY_SUCCESS, TWT_USER_TRACK_HISTORY_FAILURE, TRIGGER_TOAST } from "../constants";
import Axios from "axios";

const twtUserTrackHistory = (userId: any) => {
  return async (dispatch: any) => {
    dispatch({ type: TWT_USER_TRACK_HISTORY });
    let options = {
      headers: { 'Content-Type': 'application/json' }
    };
    await Axios.get(`${process.env.REACT_APP_PROGRESS_URL}/api/VoiceChat/VoiceChatEnable/userId/${userId}`, options).then(function (response: any) {
      dispatch({ type: TWT_USER_TRACK_HISTORY_SUCCESS, payload: response.data });
    }).catch(function (error: any) {
      dispatch({ type: TWT_USER_TRACK_HISTORY_FAILURE });
      dispatch({
        type: TRIGGER_TOAST,
        payload: {
          shouldShow: true,
          severity : 'error',
          transMessage: "message_errorDefault"
        }
      });
    });
  };
};
  
export default { twtUserTrackHistory };
  